// extracted by mini-css-extract-plugin
export default {"skeletonTile":"u3epfoQLLNBLJXYFxevX"};